import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';
import { usePreferences } from './usePreferences';

export const useGetInsightsAuthToken = () => {
  const { data: prefs } = usePreferences();
  const { primaryOrganizationId: currentOrganizationId } = useSelector(
    (state: any) => state.login.user,
  );

  const queryFn = async () => {
    const path = `${endpoints.videaInsights}/${currentOrganizationId}`;
    return await makeAPIRequestReactQuery<string>(path);
  };

  return useQuery({
    queryKey: [endpoints.videaInsights],
    queryFn,
    enabled: !!prefs?.enableInsights && prefs?.enableInsights?.length > 0,
  });
};
